var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.463,
    height: 20.349,
    viewBox: "0 0 20.463 20.349",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(-3.35 -3.35)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_32959",
    "data-name": "Tracciato 32959",
    d: "M22.663,22.5v4.036a2.018,2.018,0,0,1-2.018,2.018H6.518A2.018,2.018,0,0,1,4.5,26.536V22.5",
    transform: "translate(0 -6.005)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Unione_9",
    "data-name": "Unione 9",
    d: "M5.3,13.623.259,8.578A.888.888,0,0,1,1.514,7.322l3.534,3.533V.889a.886.886,0,1,1,1.771,0v9.965l3.534-3.531A.886.886,0,1,1,11.6,8.578L6.559,13.623a.887.887,0,0,1-.628.262A.9.9,0,0,1,5.3,13.623Z",
    transform: "translate(7.649 3.5)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.b5704f470578fdbd6b066e2ce5362c6b.svg";
export { ForwardRef as ReactComponent };